var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLastEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    fill: "none",
    viewBox: "0 0 31 31",
    id: "svg3",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13",
    transform: "translate(0,-0.8901537)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#000000",
      strokeWidth: 1.45146,
      strokeLinecap: "round"
    },
    d: "M 3.6332661,20.747819 C 3.1734709,19.379142 2.9243117,17.913745 2.9243117,16.390154 c 0,-7.5525595 6.1224965,-13.6751179 13.6749783,-13.6751176 7.552482,-6e-7 13.674979,6.1225578 13.674979,13.6751176 0,7.552558 -6.122497,13.675117 -13.674979,13.675117 -2.373692,0 -4.606127,-0.604787 -6.551627,-1.668675",
    id: "path3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 1.14996,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M 5.9025457,16.463691 C 5.6975854,16.19801 5.3663685,16.061975 5.033836,16.106903 l -2.1095243,0.283251 -2.10952545,0.283249 c -0.71638114,0.09607 -1.05980683,0.931897 -0.61791877,1.503883 l 1.29989282,1.684539 1.299893,1.684539 c 0.4407395,0.573567 1.337314,0.453907 1.6122055,-0.215172 l 0.8078718,-1.969184 0.8096322,-1.967791 c 0.1279691,-0.310016 0.080766,-0.664759 -0.1238171,-0.930526 z",
    id: "path4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g12",
    transform: "matrix(0.85018473,0.79139128,-0.79139128,0.85018473,13.569762,-7.7332815)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8",
    style: {
      fill: "#000000",
      strokeLinecap: "square"
    },
    d: "M 18.337891,8.8964844 H 13.642578 V 19.058594 l 2.347656,4.646484 2.347657,-4.646484 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11",
    style: {
      fill: "#000000",
      strokeLinecap: "square"
    },
    d: "m 15.003906,4.6914062 a 1.3612049,1.3612049 0 0 0 -1.361328,1.3613282 v 0.9863281 0.1425781 h 4.695313 V 7.0390625 6.0527344 A 1.3612049,1.3612049 0 0 0 16.976562,4.6914062 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLastEdit);
export default __webpack_public_path__ + "static/media/icon_last_edit.4cf555abdda15144c3bf41bde667d6c0.svg";
export { ForwardRef as ReactComponent };